import { useCallback, useState, useMemo } from 'react'
import { MarkerProps } from './Marker'
import { MAP_CONFIG } from './Map.data'
import { MapProps } from './Map.types'

export const useMapController = ({ locations }: Pick<MapProps, 'locations'>) => {
  const [zoom, setZoom] = useState(MAP_CONFIG.defaultZoom)
  const [selectedMarker, setSelectedMarker] = useState<MarkerProps | null>(null)

  const onMarkerClick = useCallback((marker: MarkerProps) => {
    setSelectedMarker(marker)
  }, [])

  const onMarkerClose = useCallback(() => {
    setSelectedMarker(null)
  }, [])

  const mapLocations = useMemo(
    () => [...locations].sort((a, b) => a.location.lat - b.location.lat),
    [locations],
  )

  return { zoom, setZoom, selectedMarker, onMarkerClick, onMarkerClose, mapLocations }
}
